var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Tạo ví cho trường",
            visible: _vm.showCreateCashBookDialog,
            width: "600px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "10vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.showCreateCashBookDialog = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 2 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "150px" },
                        attrs: {
                          size: "medium",
                          type: "year",
                          "value-format": "yyyy",
                          format: "yyyy",
                          placeholder: "Chọn năm",
                          clearable: false,
                        },
                        model: {
                          value: _vm.dataInput.year,
                          callback: function ($$v) {
                            _vm.$set(_vm.dataInput, "year", $$v)
                          },
                          expression: "dataInput.year",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 2, offset: 5 } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "250px" },
                          attrs: {
                            size: "medium",
                            placeholder: "Chọn trường",
                            filterable: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.dataInput.idSchool,
                            callback: function ($$v) {
                              _vm.$set(_vm.dataInput, "idSchool", $$v)
                            },
                            expression: "dataInput.idSchool",
                          },
                        },
                        _vm._l(_vm.schoolList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: {
                              label: item.id + " - " + item.schoolName,
                              value: item.id,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "20px" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 2 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "small",
                            loading: _vm.buttonLoading,
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.createCashBookOneAdminManual()
                            },
                          },
                        },
                        [_vm._v("Tạo ví cho trường\n          ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }